import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from "react-loading";

import {
	Grid,
	useTheme
} from '@material-ui/core';

function LoadingIndicator(props) {
	const theme = useTheme();
	let {type, delay, color, width, height, className} = props;

	if (color == null) {
		color = theme.palette.secondary.purple;
	}

	return (
		<Grid
			container
			justify="center"
			alignItems="center">
			<Grid item>
				<ReactLoading
					type={type}
					delay={delay}
					color={color}
					width={width}
					height={height}
					id="LoadingIndicator"
					className={className} />
			</Grid>
		</Grid>
	);
}

LoadingIndicator.defaultProps = {
	width: 128,
	height: 128,
	type: "bubbles"
};

LoadingIndicator.propTypes = {
	type: PropTypes.string,
	delay: PropTypes.number,
	color: PropTypes.string,
	className: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default LoadingIndicator;